export default build =>
    build.mutation({
        query(payload) {         
            return {
                url: '/product/deleteProductCategory',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allProductCategories']       
    })
